import { useState, useCallback } from "react";

export const useCalcEndTime = () => {
  //スタート時間とコース時間を引数にして、終了時刻の文字列を返す
  const calcEndTime = (startTime: string, courseTime: number) => {
    //前提として同一日の時間入力同士の計算なのでDate化する際の日付は固定
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    const endTimeMs = startDate.setMinutes(startDate.getMinutes() + courseTime);
    const endTime = new Date(endTimeMs);
    const hh = ("00" + endTime.getHours()).slice(-2);
    const mm = ("00" + endTime.getMinutes()).slice(-2);
    return `${hh}:${mm}`;
  };

  //時刻比較用にDate型objectを消す関数
  const calcDate = (startTime: string) => {
    //前提として同一日の時間入力同士の計算なのでDate化する際の日付は固定
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    return startDate;
  };

  //次の時間の計算
  const calcNextTime = (
    startTime: string,
    intervalTime: number, //分
    timer: number //分
  ) => {
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    const temp = Number(intervalTime) + Number(timer);
    const nextTimeMs = startDate.setMinutes(startDate.getMinutes() + temp);
    const nextTime = new Date(nextTimeMs);
    const hh = ("00" + nextTime.getHours()).slice(-2);
    const mm = ("00" + nextTime.getMinutes()).slice(-2);

    return `${hh}:${mm}`;
  };

  //一つ前の時間の計算
  const calcPrevTime = (
    startTime: string,
    intervalTime: number, //分
    timer: number //分
  ) => {
    //前提として同一日の時間入力同士の計算なのでDate化する際の日付は固定
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    const temp = Number(intervalTime) + Number(timer);
    const nextTimeMs = startDate.setMinutes(startDate.getMinutes() - temp);
    const nextTime = new Date(nextTimeMs);
    const hh = ("00" + nextTime.getHours()).slice(-2);
    const mm = ("00" + nextTime.getMinutes()).slice(-2);
    return `${hh}:${mm}`;
  };

  //TLの何番目に登録されたかで着席時間を計算
  const calcSeatingTime = (
    startTime: string,
    intervalTime: number, //分
    timer: number, //分
    tlIndex: number //TLの何番目か
  ) => {
    //前提として同一日の時間入力同士の計算なのでDate化する際の日付は固定
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    const temp = (Number(intervalTime) + Number(timer)) * tlIndex;
    const nextTimeMs = startDate.setMinutes(startDate.getMinutes() + temp);
    const nextTime = new Date(nextTimeMs);
    const hh = ("00" + nextTime.getHours()).slice(-2);
    const mm = ("00" + nextTime.getMinutes()).slice(-2);
    return `${hh}:${mm}`;
  };

  //補正時間の計算
  const calcRevisionNextTime = (
    nextTime: string,
    differTime: number, //秒
    intervalTime: number //分
  ) => {
    const wd = "2000/01/01";
    let revesionNextTimeMs: number = 0;
    const startDate = new Date(`${wd} ${nextTime}`);
    if (differTime / 60 > intervalTime) {
      revesionNextTimeMs = startDate.setMinutes(
        startDate.getMinutes() + differTime / 60
      );
    }
    if (differTime / 60 < intervalTime) {
      revesionNextTimeMs = startDate.setMinutes(
        startDate.getMinutes() + differTime / 60 - intervalTime
      );
    }
    const revesionNextTime = new Date(revesionNextTimeMs);
    const hh = ("00" + revesionNextTime.getHours()).slice(-2);
    const mm = ("00" + revesionNextTime.getMinutes()).slice(-2);
    return `${hh}:${mm}`;
  };

  //時間の足し算
  // const calcAddTime =(
  //   time1:string,
  //   time2:string
  // )=>{
  //   const wd = "2000/01/01";

  // };

  return {
    calcEndTime,
    calcDate,
    calcNextTime,
    calcPrevTime,
    calcSeatingTime,
    calcRevisionNextTime,
  };
};
